import { render, staticRenderFns } from "./what-i-do.vue?vue&type=template&id=f5ba5f32&scoped=true&"
import script from "./what-i-do.vue?vue&type=script&lang=js&"
export * from "./what-i-do.vue?vue&type=script&lang=js&"
import style0 from "./what-i-do.vue?vue&type=style&index=0&id=f5ba5f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba5f32",
  null
  
)

export default component.exports